<template>
    <div class="sign_on_dialog">
        <InputBar :use_phone="use_phone" :use_password="use_password"
                  @signOnInfo="update_u_p"
                  @emit_login="login(loginArgs)"
        ></InputBar>
        <div v-if="!use_password" class="input-group input_group" @keyup.enter="login(loginArgs)">
            <el-input placeholder="请输入短信验证码" v-model="verification_code"></el-input>
            <el-link v-if="countdown>0" style="position: absolute;right: 0px;top: 10px;" disabled>{{countdown}}秒后可重发</el-link>
            <el-link v-else style="position: absolute;right: 0px;top: 10px;" @click="send_verification_xyz" type="primary" :underline="false">获取短信验证码</el-link>
        </div>
        <div class="custom_control_div">
            <div>
                <!--<a v-if="use_phone" @click="change_use_phone" href="javascript:;">使用邮箱登录</a>-->
                <!--<a v-else @click="change_use_phone" href="javascript:;">使用手机登录</a>-->
                <el-link v-if="use_password" @click="change_use_password" type="primary" :underline="false">使用短信验证登录
                </el-link>
                <el-link v-else @click="change_use_password" type="primary" :underline="false">使用密码验证登录</el-link>
            </div>
            <div>

                <router-link v-if="use_password" tag="a"
                             :to="{ name: 'password_find' }" target="_blank"
                >
                     <el-link>忘记密码</el-link>
                </router-link>
                <!--<span v-else>-->
                    <!--<el-link v-if="countdown>0" disabled>{{countdown}}秒后可重发</el-link>-->
                    <!--<el-link v-else @click="send_verification_xyz" type="primary" :underline="false">获取短信验证码</el-link>-->
                <!--</span>-->

            </div>
        </div>
        <a class="enter_button" href="javascript:;" @click="login(loginArgs)">进入成长之路</a>
    </div>
</template>

<script type="text/javascript">
    import InputBar from './sub_components/input_bar.vue'
    import loginApi from '@/api/login/login.js'

    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            input_id: {
                type: String,
                require: false
            }
        },
        data() {
            return {
                // username: ,password:
                base_login_args: {},
                checked: '',
                use_phone: true,
                use_password: true,
                verification_code: '',
                countdown: 0,
            }
        },
        components: {
            InputBar
        },
        computed: {
            loginArgs: function () {
                let args = {...this.base_login_args}
                if (this.checked) {
                    args['remember'] = true
                } else {
                    args['remember'] = false
                }
                if (this.input_id) {
                    args['login_page'] = true
                }
                // verification 暂无
                args.use_phone = this.use_phone
                args.use_password = this.use_password
                args.verification_code = this.verification_code
                return args
            },
            ...mapState({
                login_state_info: function (state) {
                    return {
                        'state': state.loginState.login_info.state,
                        'state_message': state.loginState.login_info.state_message
                    }
                }
            })
        },
        methods: {
            ...mapActions({
                get_login_info: 'loginState/get_and_change_all_login',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            login: function (loginArgs) {
                this.get_login_info(loginArgs)
            },
            update_u_p: function (data) {
                this.base_login_args = data
            },
            change_use_phone() {
                this.use_phone = !this.use_phone
            },
            change_use_password() {
                this.use_password = !this.use_password
            },
            send_verification_xyz() {
                let args = {
                    'type': 'login',
                    'phone': this.loginArgs.login,
                }
                loginApi.send_verification_xyz(args).then(res => {
                    console.log(res)
                    let data = JSON.parse(res.data.result)
                    this.change_warning_message(data.message);
                    if (data.code === 'success') {
                        this.change_warning_bar_style_class('success');
                        var that = this
                        that.countdown = 60;
                        var interval = setInterval(function () {
                            that.countdown -= 1;
                            if (that.countdown === 0) {
                                clearInterval(interval);
                            }
                        }, 1000);
                    } else {
                        this.change_warning_bar_style_class('alert');
                    }
                })
            },
        }
    }
</script>

<style type="text/css" scoped>
    >>> .el-input__inner {
        border: none;
    }

    .input_group {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;
    }

    .enter_button {
        display: block;
        width: 100%;
        color: #fff;
        margin-top: 30px;
        background: #6CF;
        padding: 6px 12px;
        font-size: 14px;
        text-align: center;
        border: 1px solid #6CF;
        border-radius: 20px;
    }

    .enter_button:hover {
        background: #6CE;
        color: #fff;
    }

    .login_state_message {
        padding: 5px 10px;
        margin-top: 10px;
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 14px;
        background-color: #f2dede;
        border-color: #ebccd1;
        color: #a94442;
    }

    .custom_control_div {
        display: flex;
        justify-content: space-between;
        /*align-items: center;*/
        color: #999;
        font-size: 14px;
    }

    .autologin_label {
        position: relative;
    }

    .autologinbutton {
        opacity: 0;
    }

    .autologin_label:after {
        position: absolute;
        top: .25rem;
        /*top: 0;*/
        left: -1.1rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
        background: no-repeat 50%/50% 50%;
    }

    .autologin_label:before {
        content: "";
        border-radius: .25rem;
        border: 1px solid #adb5bd;
        background-color: #fff;
        pointer-events: none;
        width: 1rem;
        height: 1rem;
        position: absolute;
        top: .25rem;
        left: -1.1rem;
        display: block;
        transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .label_checked:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3E%3C/svg%3E");
    }

    .label_checked:before {
        color: #fff;
        background-color: #66CCFF;
        border-color: #66CCFF;
    }


    /*
    https://stackoverflow.com/questions/10782054/what-does-the-tilde-squiggle-twiddle-css-selector-mean
    for more ~ selector information.
     */
    .autologinbutton:active ~ .autologin_label:before {
        color: #fff;
        background-color: #80fadb;
        border-color: #80fadb;
    }

    .autologinbutton:focus ~ .autologin_label:before {
        box-shadow: 0 0 0 0.2rem rgba(8, 191, 145, .25);
    }

    /* */
    .forget_password {
        color: #c6c6c6;
    }

    .forget_password:hover {
        color: #c6c6c6;
    }

</style>
